import * as React from 'react';
import { DataGrid } from '@mui/x-data-grid';
import '../../Style/Data.module.css';
import Loader from '../../../../Loader/Loader';



export default function UploadTable({ receivedData, disableBtn, setDisableBtn }) {


  const columns = [
    {
      field: 'module',
      headerName: 'Module',
      minWidth: 150,
      flex: 1,
      align: 'center',
      headerClassName: 'header-blue',
      sortable: false,
    },
    {
      field: 'status',
      headerName: 'Status',
      minWidth: 150,
      flex: 1,
      align: 'center',
      headerClassName: 'header-blue',
      sortable: false,
    },

  ];



  return (
    <div style={{ height: '100%', width: '100%', overflowY: "auto" }}>
      {receivedData ? <DataGrid

        sx={{
          width: 'fit-content', '& .MuiDataGrid-columnHeaderTitleContainer': { justifyContent: "center" },
          "& .MuiDataGrid-withBorderColor": {
            borderRight: "none",
          },
          "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
          '& .MuiDataGrid-virtualScroller::-webkit-scrollbar': { display: 'none' },
          "& .MuiDataGrid-columnHeaders": {width: "fit-content"},
          "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": { py: "5px" },
          "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
            py: "8px",
          },
          "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
            py: "15px",
          },
        }}

        style={{
          color: "#154063",
          width: "100%",
          whiteSpace: "nowrap",
          height: "100%",
          borderWidth: "2px",
          borderRadius: "10px",
        }}
        

        rows={receivedData}
        columns={columns}
        getRowId={(row) => row.id}
        disableRowSelectionOnClick
        disableColumnMenu
        disableRowCount
        showCellVerticalBorder
        disableColumnSelector
        scrollbarSize={0}
        autoPageSize
      /> : <Loader />}
    </div>
  );
}